import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../../../utils/Common";
import HeadRegresar from "../../sharecomponents/HeadRegresar";
/// import BoxAlert from "../../sharecomponents/BoxAlert";
import ButtonIconLink from "../../sharecomponents/ButtonIconLink";
//import MatrizProtocolo from "./MatrizProtocolo";
//import VariedadesFlor from "./VariedadesFlor";
import CiclosCurvaCosecha from "./CiclosCurvaCosecha";

const InfoFlor = (props) => {
   const idFlor = props.match.params.id; // -- el ID es del tipo de FLor
   const [infoFlor, updateInfoFlor] = useState(null);

   useEffect(() => {
      axios
         .get(API_URL + "/flor/getFlor?id=" + idFlor)
         .then((r) => {
            updateInfoFlor(r.data);
         })
         .catch((err) => console.log(err));
   }, [idFlor]);

   return (
      <div className="w-full p-3">
         <div className="bg-white border rounded shadow">
            <div className="border-b rounded-t p-3 bg-orange-900">
               <HeadRegresar titulo="Detalle del Tipo de Flor" history={props.history} />
            </div>
            <div className="p-5 rounded-b">
               {infoFlor && (
                  <React.Fragment>
                     <div className="mb-5 bg-orange-100 shadow-xl overflow-hidden rounded-lg border border-orange-200">
                        <div className="px-4 py-5 border-b border-gray-200 sm:px-6">
                           <div className="flex flex-wrap">
                              <div className="w-1/4 px-3">
                                 <h3 className="text-lg uppercase leading-6 font-medium text-orange-900">
                                    {infoFlor.tipoFlor[0].variedad} {infoFlor.tipoFlor[0].color}
                                 </h3>
                                 <p className="mt-1 mb-1 ml-1 max-w-2xl text-sm leading-5 text-gray-500 font-bold">
                                    {infoFlor.info.nombre_comun}
                                 </p>
                                 <ButtonIconLink
                                    iconClass="fas fa-edit"
                                    titulo="Editar Flor"
                                    disabled={false}
                                    history={props.history}
                                    to={"/editar_flor/" + infoFlor.tipoFlor[0].florId}
                                 />
                              </div>
                              <div className="w-1/4 px-3 text-sm leading-5 font-medium text-gray-600">
                                 <ul className="list-disc">
                                    <li>
                                       Densidad: <b className="text-orange-900">{infoFlor.info.densidadm2}</b>
                                    </li>
                                    <li>
                                       Porcentaje Recuperación:{" "}
                                       <b className="text-orange-900">{infoFlor.info.porcentaje}</b>
                                    </li>
                                    <li>
                                       Cavidad: <b className="text-orange-900">{infoFlor.info.cavidad}</b>
                                    </li>
                                    <li>
                                       Germinación: <b className="text-orange-900">{infoFlor.info.germinacion}</b>
                                    </li>
                                 </ul>
                              </div>
                           </div>
                        </div>
                     </div>

                     <CiclosCurvaCosecha florid={idFlor} />
                  </React.Fragment>
               )}
            </div>
         </div>
      </div>
   );
};

export default InfoFlor;
